import React from 'react';
import { motion } from 'framer-motion';
const smoothEase = [0.22, 1, 0.36, 1];
export function GallerySection() {
  return <section className="w-full py-28 md:py-36" data-id="element-58">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-59">
        {/* Editorial Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        ease: smoothEase
      }} className="max-w-4xl mx-auto text-center mb-28" data-id="element-60">
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: smoothEase
        }} className="w-16 h-px bg-luxury-gold/50 mx-auto mb-10" data-id="element-61" />

          <h3 className="font-playfair text-2xl md:text-3xl lg:text-[2.75rem] text-luxury-cream leading-snug italic" data-id="element-62">
            A distinguished Victorian residence
            <br className="hidden md:block" data-id="element-63" />
            <span className="text-luxury-taupe" data-id="element-64"> in the heart of Armadale</span>
          </h3>
        </motion.div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 mb-28" data-id="element-65">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 1,
          ease: smoothEase
        }} className="md:col-span-7 h-[55vh] md:h-[80vh] overflow-hidden group rounded-sm" data-id="element-66">
            <img src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80" alt="Luxury interior living space" className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-[1.03]" data-id="element-67" />
          </motion.div>

          <div className="md:col-span-5 flex flex-col gap-4 md:gap-5 h-auto md:h-[80vh]" data-id="element-68">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 1,
            delay: 0.15,
            ease: smoothEase
          }} className="flex-1 overflow-hidden group rounded-sm" data-id="element-69">
              <img src="https://images.unsplash.com/photo-1600210492486-554a9d3c4a44?w=800&q=80" alt="Elegant room detail" className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-[1.03]" data-id="element-70" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 1,
            delay: 0.3,
            ease: smoothEase
          }} className="flex-1 overflow-hidden group rounded-sm" data-id="element-71">
              <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80" alt="Home exterior detail" className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-[1.03]" data-id="element-72" />
            </motion.div>
          </div>
        </div>

        {/* Video Tour */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        ease: smoothEase
      }} className="max-w-5xl mx-auto mb-28" data-id="element-73">
          <span className="block text-luxury-gold text-[11px] tracking-[0.3em] uppercase text-center mb-6" data-id="element-74">
            Property Tour
          </span>
          <div className="relative w-full overflow-hidden rounded-sm shadow-lg" style={{
          paddingBottom: '56.25%'
        }} data-id="element-75">
            <iframe src="https://www.youtube.com/embed/DKj9pCjrAg4?rel=0&modestbranding=1&color=white" title="10 Union Street, Armadale — Property Tour" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full border-0" data-id="element-76" />
          </div>
        </motion.div>

        {/* Description */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.9,
        ease: smoothEase
      }} className="max-w-2xl mx-auto text-center" data-id="element-77">
          <p className="text-luxury-taupe text-base md:text-lg leading-[1.85] font-light" data-id="element-78">
            Behind an ornate Victorian façade lies a masterfully preserved
            residence of rare grandeur. Period details — original tessellated
            tiles, soaring ceilings, and intricate timber fretwork — meet
            considered modern updates across generous proportions on one of
            Armadale's most coveted streets.
          </p>
        </motion.div>
      </div>
    </section>;
}